import DelegatedInquiry from './delegated-inquiry.vue'
export default DelegatedInquiry
